import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import JournalsEditor from "./JournalsEditor";

const JournalsEditorPage = () => {
  const { journalId } = useParams();
  const navigate = useNavigate();
  const [journal, setJournal] = useState(null);
  const [loading, setLoading] = useState(true);

  const isNew = journalId === "new";

  const createEmptyJournal = () => ({
    _id: crypto.randomUUID(),
    name: "New Journal",
    type: "",
    transactionReference: "",
    journalLines: [],

  });

  useEffect(() => {
    const fetchJournal = async () => {
      if (isNew) {
        setJournal(createEmptyJournal());
        setLoading(false);
      } else {
        try {
          const res = await fetch(`https://ledgers.poc.mrc.ai/api/journals/${journalId}`);
          const data = await res.json();
          setJournal(data);
        } catch (error) {
          console.error("Error fetching Journal:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchJournal();
  }, [journalId, isNew]);

  const handleSave = async (updatedJournal) => {
  try {
    const method = isNew ? "POST" : "PUT";
    const url = isNew
      ? `https://ledgers.poc.mrc.ai/api/journals`
      : `https://ledgers.poc.mrc.ai/api/journals/${journalId}`;

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedJournal),
    });

    if (!res.ok) throw new Error("Failed to save Journal");

    const saved = await res.json();
    setJournal(saved);
  } catch (err) {
    console.error("Error saving Journal:", err);
  }
};

  const handleClose = () => navigate("/");

  if (loading) return <Spinner />;

  return <JournalsEditor journal={journal} onClose={handleClose} isNew={isNew} />;
};

export default JournalsEditorPage;
